/** @format */

import { Box, Tabs, Tab } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { colors } from "../../utility/types/constant";
import ThemeProvider from "../../theme";
import FAQ from "../faq/FAQ";
import { StyledTypography } from "./styles";

interface TabPanelProps {
	children?: React.ReactNode;
	dir?: string;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<div>{children}</div>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

const GeneralTab = () => {
	const { t } = useTranslation("home");
	const [value, setValue] = React.useState(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	return (
		<ThemeProvider>
			<Box
				sx={{
					width: "100%",
					mt: 25,
					mb: 25,
				}}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="basic tabs example"
						variant="fullWidth">
						<Tab
							sx={{ fontSize: 20, color: colors.headerColor }}
							label={t("generalTab.overview")}
							{...a11yProps(0)}
						/>
						<Tab
							sx={{ fontSize: 20, color: colors.headerColor }}
							label={t("generalTab.faq")}
							{...a11yProps(1)}
						/>
						<Tab
							sx={{ fontSize: 20, color: colors.headerColor }}
							label={t("generalTab.license")}
							{...a11yProps(2)}
						/>
					</Tabs>
				</Box>
				<CustomTabPanel value={value} index={0}>
					<StyledTypography>
						{t("generalTab.description")}
					</StyledTypography>
				</CustomTabPanel>
				<CustomTabPanel value={value} index={1}>
					<FAQ />
				</CustomTabPanel>
				<CustomTabPanel value={value} index={2}>
					<StyledTypography>
						{t("generalTab.disclaimer")}
					</StyledTypography>
				</CustomTabPanel>
			</Box>
		</ThemeProvider>
	);
};

export default GeneralTab;
